import { useEffect, useMemo, useState } from 'react';

import { getAvatar } from '@/utils/img';

const useAvatar = (userid: any) => {
  const lastId = (userid && userid?.toString()?.slice(-1)) ?? 0;

  return useMemo(() => {
    return `${window.imgPrefix}/img/avatar/default_img_man_${lastId}.webp`;
  }, [lastId]);
};

export const useAvatarV2 = value => {
  const [url, setUrl] = useState('');
  useEffect(() => {
    const newUrl = getAvatar(value);
    setUrl(newUrl);
  }, [value]);

  return {
    url
  };
};

export default useAvatar;
